import { render } from "./eventLeague_view.vue?vue&type=template&id=03fd8fb0"
import script from "./eventLeague_view.vue?vue&type=script&lang=js"
export * from "./eventLeague_view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__